// addresses modules
import axios from '@/api/http_client';
import {getToken} from '@/common'
import { ADDRESS_URL, DEFAULT_ADDRESS_URL } from '../../api/url.js';
import { STATES } from '../../../config/default';

// initial state
const state = {
  customerDetails: [],
  defaultAddress: {},
  states: STATES,
  // successfullyPosted: false,
}

// actions
const actions = {
  // fetchAddresses
  async fetchAddresses(context, callback) {
    const token = getToken();
    const config = {
      method: 'get',
      url: ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config)
    .then((response) => {
      context.commit('fetchAddresses', response.data);
      if (callback) {
        callback();
      }
    }, (err) => {
      console.log("fetchAddresses error:", err);
    })
  },
  // fetchAddresses
  async fetchDefaultAddress(context) {
    const token = getToken();
    const config = {
      method: 'get',
      url: DEFAULT_ADDRESS_URL,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
  await axios(config)
    .then((response) => {
      context.commit('fetchDefaultAddress', response.data);
    }, (err) => {
      console.log("fetchDefaultAddress error:", err);
    })
  },
  // postAddress
  async postAddress({ commit, dispatch }, data) {
    console.log("data:", data)
    let address, type;
    if (!Array.isArray(data)) {
      address = data;
    } else {
      address = data[0];
      type = data[1];
    }
    const token = getToken();
    const config = {
      method: 'post',
      url: ADDRESS_URL,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
    // .then((response) => {
    //   dispatch('fetchAddresses');
    // }, (err) => {
    //   alert('error happen when create address, please contact us.');
    // })
  },
  // editAddress
  editAddress(context,[address, customerDetail_id]) {
    const token = getToken();
    const config = {
      method: 'put',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      data: address,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
    // .then((response) => {
    //   location.reload();
    // }, (err) => {
    //   alert('error happen when edit address, please contact us.');
    // })
  },
  // deleteAddress
  async deleteAddress({ dispatch }, customerDetail_id) {
    const token = getToken();
    const config = {
      method: 'delete',
      url: `${ADDRESS_URL}/${customerDetail_id}`,
      headers: {
         Authorization: `JWT ${token}`,
      },
    };
    return axios(config)
    .then((response) => {
      dispatch('fetchAddresses')
      return true
      // location.reload();
    }, (err) => {
      alert('error happen when delete address, please contact us.');
      return false
    })
  },
};

// mutations
const mutations = {
  fetchAddresses(state, payload) {
    state.customerDetails = payload.Customer_Detail
  },
  fetchDefaultAddress(state, payload) {
    state.defaultAddress = payload
  }
}

export default {
  strict: true,
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js